import * as React from "react";
import { StarIcon } from "../../../../../../components/StarIcon";
import { px2rem } from "../../../../../utils/css";
import { StarAndSoldLine, LeftStar, LeftStarNum, RightSold } from "./styles";
export const StarAndSold = (props) => {
    const { star = 0, sold } = props;
    return (React.createElement(StarAndSoldLine, null,
        !!star && (React.createElement(LeftStar, null,
            new Array(star).fill("").map((_, index) => {
                return React.createElement(StarIcon, { key: index, size: px2rem(10) });
            }),
            React.createElement(LeftStarNum, null, `${star}.0`))),
        React.createElement(RightSold, { hasStar: !!star }, sold)));
};
